export enum EHolidayType {
  OTHER = 'other',
  RELIGIOUS = 'religious',
  NATIONAL = 'national',
}
